export const LANGUAGES: ILanguage[] = [
  { code: "am", label: "አማርኛ (Amharic)" },
  { code: "ar", label: "العربية (Arabic)" },
  { code: "bg", label: "български (Bulgarian)" },
  { code: "bn", label: "বাংলা (Bengali)" },
  { code: "ca", label: "Català (Catalan)" },
  { code: "cs", label: "čeština (Czech)" },
  { code: "da", label: "Danish (Denmark)" },
  { code: "de", label: "Deutsch (German)" },
  { code: "el", label: "Ελληνικά (Greek)" },
  { code: "en", label: "English (English)" },
  { code: "es", label: "Español (Spanish)" },
  { code: "fa", label: "فارسی (Persian)" },
  { code: "fi", label: "suomi (Finnish)" },
  { code: "fil", label: "Tagalog (Filipno)" },
  { code: "fr", label: "Français (French)" },
  { code: "he", label: "עברית (Hebrew)" },
  { code: "hi", label: "हिन्दी (Hindi)" },
  { code: "hr", label: "Hrvatski (Croatian)" },
  { code: "hu", label: "Magyar (Hungarian)" },
  { code: "id", label: "Bahasa Indonesia (Indonesian)" },
  { code: "it", label: "Italiano (Italian)" },
  { code: "ja", label: "日本語 (Japanese)" },
  { code: "ka", label: "ქართული (Georgian)" },
  { code: "kn", label: "ಕನ್ನಡ (Kannada)" },
  { code: "ko", label: "한국어 (Korean)" },
  { code: "ku", label: "Kurdî (Kurdish)" },
  { code: "lt", label: "Lietuvių (Lithuanian)" },
  { code: "lv", label: "Latviešu (Latvian)" },
  { code: "lb", label: "Lëtzebuergesch (Luxembourgish)" },
  { code: "ml", label: "മലയാളം (Malayalam)" },
  { code: "mn", label: "Монгол (Mongolian)" },
  { code: "ms", label: "Bahasa Malaysia (Malay)" },
  { code: "my", label: "မြန်မာ (Burmese)" },
  { code: "nb", label: "Norsk bokmål (Norwegian Bokmål)" },
  { code: "nl", label: "Nederlands (Dutch)" },
  { code: "no", label: "Norsk (Norwegian)" },
  { code: "pa", label: "ਪੰਜਾਬੀ (Punjabi)" },
  { code: "pl", label: "Polski (Polish)" },
  { code: "pt", label: "Português (Portuguese)" },
  { code: "ro", label: "Română (Romanian)" },
  { code: "ru", label: "Русский (Russian)" },
  { code: "si", label: "සිංහල (Sinhala)" },
  { code: "sk", label: "slovenčina (Slovak)" },
  { code: "sl", label: "slovenščina (Slovenian)" },
  { code: "sr", label: "Srpski (Serbian)" },
  { code: "sv", label: "Svenska (Swedish)" },
  { code: "sw", label: "Kiswahili (Swahili)" },
  { code: "ta", label: "தமிழ் (Tamil)" },
  { code: "te", label: "తెలుగు (Telugu)" },
  { code: "th", label: "ไทย (Thai)" },
  { code: "tr", label: "Türkçe (Turkish)" },
  { code: "ur", label: "اردو (Urdu)" },
  { code: "vi", label: "Tiếng Việt (Vietnamese)" },
];

const locales = LANGUAGES.map(lang => lang.code);
export interface ILanguage {
  code: string;
  label: string;
  [key: string]: string;
}

export const LANGUAGE_DICTIONARY: Record<string, ILanguage> = {};

// Track if languages are loaded
let languagesLoaded = false;
let languagesLoadingPromise: Promise<void> | null = null;

// @ts-ignore
export async function loadLanguages(): Promise<void> {
  // If already loaded, return immediately
  if (languagesLoaded) {
    return;
  }
  
  // If already loading, return the existing promise
  if (languagesLoadingPromise) {
    return languagesLoadingPromise;
  }
  
  // Start loading
  languagesLoadingPromise = (async () => {
    try {
      for (const locale of locales) {
        // @ts-ignore
        LANGUAGE_DICTIONARY[locale] = (await import(`../locales/${locale}.json`)).default;
      }
      languagesLoaded = true;
    } catch (error) {
      console.error('Failed to load languages:', error);
      throw error;
    }
  })();
  
  return languagesLoadingPromise;
}

// Initialize languages when module is imported
loadLanguages();